import {useMutation} from '@tanstack/react-query';
import {UseFormReturn} from 'react-hook-form';
import {BackendResponse} from '../../http/backend-response/backend-response';
import {toast} from '../../ui/toast/toast';
import {apiClient, queryClient} from '../../http/query-client';
import {WorkspaceQueryKeys} from './workspace-query-keys';
import {Workspace} from '../types/workspace';
import {onFormQueryError} from '../../errors/on-form-query-error';
import {useDialogContext} from '../../ui/overlays/dialog/dialog-context';
import {message} from '../../i18n/message';
import {invalidateEntryQueries} from "@app/drive/drive-query-keys";

interface Response extends BackendResponse {
  workspace: Workspace;
}

export interface VerifyPinPayload {
  id: number;
  pin: string;
  setSession: boolean;
}

async function verifyPinWorkspace({id, ...props}: VerifyPinPayload): Promise<Response> {
  const r = await apiClient.post(`workspace/${id}/pin-verify`, props);
  return r.data;
}

export function useVerifyPin(
  form: UseFormReturn<VerifyPinPayload>,
  onVerified: (pin: string) => void,
) {
  const {close} = useDialogContext();
  return useMutation({
    mutationFn: (props: VerifyPinPayload) => verifyPinWorkspace(props),
    onSuccess: _response => {
      queryClient.invalidateQueries({
        queryKey: WorkspaceQueryKeys.fetchUserWorkspaces,
      });
      queryClient.invalidateQueries({
        queryKey: WorkspaceQueryKeys.workspaceWithMembers(
          form.getValues().id,
        ),
      });
      onVerified(form.getValues().pin);
      close();
      return invalidateEntryQueries();
    },
    onError: r => {
      onFormQueryError(r, form);
    }
  });
}
